import { theme } from "@product/scmp-sdk";
import type { FunctionComponent, ReactNode } from "react";

import { useAppBarStickyHeightValue } from "~/components/app-bar/hooks";
import type { DefaultComponentsProvider } from "~/components/article/article-render";

import { DesktopRightSectionAdSlot, Right, RightSection, RightSectionSticky } from "./styles";

type Props = {
  className?: string;
  entityId: string;
  provider: DefaultComponentsProvider;
  rightSectionCustomSlot?: ReactNode;
  shouldRender: boolean;
  shouldRenderNewsletterWidget?: boolean;
  shouldRenderRemaining: boolean;
  shouldRenderSecondAd: boolean;
};

export const ArticleContentRightSection: FunctionComponent<Props> = ({
  className,
  entityId,
  provider,
  rightSectionCustomSlot,
  shouldRender,
  shouldRenderRemaining,
  shouldRenderSecondAd,
}) => {
  const { appBarStickyHeight } = useAppBarStickyHeightValue();

  return shouldRender ? (
    <Right className={className}>
      <RightSection>
        <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
          <DesktopRightSectionAdSlot>
            {provider.adslot({
              adUnit: "d_lrec1",
              autoRefreshOptions: {
                scrollBackRefreshOptions: { slotArticleEntityId: entityId },
              },
              breakpoint: theme.breakpoints.up("desktop"),
              sizes: [[300, 250], [300, 600], "fluid"],
            })}
          </DesktopRightSectionAdSlot>
          {shouldRenderSecondAd && (
            <DesktopRightSectionAdSlot>
              {provider.adslot({
                adUnit: "native4",
                breakpoint: theme.breakpoints.up("desktop"),
                fluidDefaultSize: {
                  height: 260,
                },
                sizes: ["fluid"],
              })}
            </DesktopRightSectionAdSlot>
          )}
          {rightSectionCustomSlot}
        </RightSectionSticky>
      </RightSection>
      {shouldRenderRemaining && (
        <>
          {provider.moreOnThis({ variant: "vertical" })}
          <RightSection>
            <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
              <DesktopRightSectionAdSlot>
                {provider.adslot({
                  adUnit: "d_lrec2",
                  autoRefreshOptions: {
                    scrollBackRefreshOptions: { slotArticleEntityId: entityId },
                  },
                  breakpoint: theme.breakpoints.up("desktop"),
                  sizes: [[300, 250], [300, 600], [320, 480], "fluid"],
                })}
              </DesktopRightSectionAdSlot>
            </RightSectionSticky>
          </RightSection>
          <RightSection>
            <RightSectionSticky $stickyStackedHeight={appBarStickyHeight}>
              <DesktopRightSectionAdSlot>
                {provider.adslot({
                  adUnit: "d_lrec3b",
                  autoRefreshOptions: {
                    scrollBackRefreshOptions: { slotArticleEntityId: entityId },
                  },
                  breakpoint: theme.breakpoints.up("desktop"),
                  sizes: [[300, 250], [300, 600], [320, 480], "fluid"],
                })}
              </DesktopRightSectionAdSlot>
            </RightSectionSticky>
          </RightSection>
        </>
      )}
    </Right>
  ) : null;
};
